import React, { useEffect, useState } from 'react';
import { IWizardItem } from '../Components/WizardItems/WizardItem';
import { WizardItemType } from '../Enums/WizardItemType.enum';
import { WizardScreenData } from '../Components/Wizard/GetWizard';

interface WizardData {
	step?: string;
	entityId?: string;
	type?: string;
	data?: object;
}

export interface WizardContextProps {
	activeScreen?: IWizardItem;
	activeScreenData?: WizardScreenData;
	setWizardScheme: (newState: any) => void;
	handleSetScreen: (key: string, screenData?: WizardScreenData) => void;
	wizardData?: WizardData;
	setWizardData: (newState: WizardData) => void;
}

export interface WizardContextProviderProps {
	values?: WizardContextProps;
	children?: React.ReactChild | React.ReactChild[];
}

export const WizardContext = React.createContext<WizardContextProps>({
	activeScreen: undefined,
	activeScreenData: undefined,
	setWizardScheme: () => {},
	handleSetScreen: () => {},
	wizardData: undefined,
	setWizardData: () => {},
});

export const useWizardContext: () => WizardContextProps = () =>
	React.useContext<WizardContextProps>(WizardContext);

export function WizardContextProvider({
	values,
	children,
}: WizardContextProviderProps) {
	const [activeScreen, setActiveScreen] = useState(values?.activeScreen);
	const [activeScreenData, setActiveScreenData] = useState(
		values?.activeScreenData,
	);
	const [wizardScheme, setWizardScheme] = useState<IWizardItem[]>();
	const [wizardData, setWizardData] = useState<WizardData>();

	useEffect(() => {
		if (wizardScheme) {
			setActiveScreen(
				wizardScheme.find(item => item.type === WizardItemType.DYNAMIC),
			);
		}
	}, [wizardScheme]);

	const handleSetScreen = (key: string, screenData?: WizardScreenData) => {
		if (wizardScheme) {
			setActiveScreen(
				wizardScheme.find(
					item => item.type === WizardItemType.DYNAMIC && item.key === key,
				),
			);
			setActiveScreenData(screenData);
		}
	};

	return (
		<WizardContext.Provider
			value={{
				activeScreen,
				activeScreenData,
				setWizardScheme,
				handleSetScreen,
				wizardData,
				setWizardData,
			}}
		>
			{children}
		</WizardContext.Provider>
	);
}
